<template>
	<div id="app">
		<router-view />
		<PanoViewer v-show="isPanoViewerVisible"></PanoViewer>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PanoViewer from "@/components/PanoViewer.vue";
export default {
	components: {
		PanoViewer,
	},
	data: () => ({}),
	computed: {
		...mapGetters(["isPanoViewerVisible"]),
	},
	created() {
		// await this.fetchLooks(
		// 	this.$route.query.lookid ? this.$route.query.lookid : ""
		// );
	},
	methods: {
		...mapActions(["fetchLooks"]),
	},
};
</script>

<style lang="scss">
#app {
	height: 100%;
	width: 100%;
}
</style>
